import DriverInfo from './styled';

export default DriverInfo;
